const campaignObjectives = [
  { label: "Conversion", value: "Conversion" },
  { label: "Increase sales", value: "Increase sales" },
  { label: "Awareness", value: "Awareness" },
  { label: "Retention", value: "Retention" },
];
export default campaignObjectives;
